import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Log } from '../util/log';
import { DeviceService } from '../service/device.service';

@Component({
  selector: 'app-migration-dialog',
  templateUrl: './migration-dialog.component.html',
  styleUrls: ['./migration-dialog.component.css']
})

export class MigrationDialogComponent implements OnInit {
  @ViewChild('loader', { static: true }) loader;


  ownerUid: string;
  originSerial: string;
  destinationSerial: string;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private deviceService: DeviceService,
    public dialogRef: MatDialogRef<MigrationDialogComponent>
  ) {
    this.ownerUid = data.ownerUid;
    this.originSerial = data.originSerial;

    Log.debug("this originSerial is: ");
    Log.debug(this.originSerial);

    Log.debug("this ownerUid is: ");
    Log.debug(this.ownerUid);

  }

  ngOnInit(): void {
    this.loader.hideLoading();

  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }


  closeDialog() {
    this.dialogRef.close();
  }

  beginMigration() {
    this.loader.showLoading();
    Log.debug("Starting migration! from " + this.originSerial + " to  " + this.destinationSerial + " with ownerUid:  " + this.ownerUid);
    // TODO mettere un qualche controllo in più, es get del seriale e dialog di conferma col nome dell'impianto

    this.deviceService.migrateDevice(this.originSerial, this.destinationSerial, this.ownerUid).subscribe(res => {

      Log.debug("\n\tmigrateDevice response is: ");
      Log.debug(res)
      this.loader.hideLoading();
    }, err => {
      Log.debug("\n\tmigrateDevice error response is: ");
      Log.debug(err)
      this.loader.showError();
    });


  }


}